import { useEffect, useRef, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import logo from "../../assets/icons/logo.png";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import {
  cmsAdminIconArray,
  curriculumAdminIconArray,
  iconArray,
  navActiveCss,
  navHoverCss,
  superAdminIconArray,
  testimonialAdminIconArray,
  TWGIconArray,
  ChurchesIconArray,
  ChannelsIconArray,
  MinistriesIconArray,
  churchPortalOnlyIconArray,
  channelPortalOnlyIconArray,
  ministryPortalOnlyIconArray,
  ChannelFieldTabsIconArray,
  ChurchFieldTabsIconArray,
  MinistryFieldTabsIconArray,
} from "../../constants/NavbarConstants";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAction } from "../../store/Profile/ProfileAction";
import {
  setUserAccessTokenAction,
  updateUserProfileInfoAction,
} from "../../store/Users/UsersAction";
import NavigationConfirmModal from "./NavigationConfirmModal";
import {
  CMS_ADMIN,
  CURRICULUM_ADMIN,
  SUPER_ADMIN,
  TESTIMONIAL_ADMIN,
} from "../../screens/Users/Constants";
import {
  getCurrentHostMode,
  pickPreferredCmsProfile,
  resolveProfilePortalAccess,
} from "../../utils/portalAccess";
import {
  getLanguageListAction,
  updateRawLanguageListAction,
} from "../../store/Languages/LanguageAction";
import Tab from "./Tab";

function Navbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const { userInfo, accessToken } = useSelector((state) => state.user);
  const displayName =
    [userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(" ") ||
    userInfo?.name ||
    userInfo?.email ||
    "User";
  const isChurchAdmin = userInfo?.roleName === "Church Admin";
  const { rawLanguagesList } = useSelector((state) => state.language);
   // 👇 Get selected tab from redux
  const selectedTab = useSelector((state) => state.tab.selectedTab);

  useEffect(() => {
      }, [selectedTab]); // log whenever it changes

  const [checkToken, setCheckToken] = useState(localStorage.getItem("token"));
  const [activeMenus, setActiveMenus] = useState([iconArray]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(true);
  const iconListRef = useRef(null);
  const iconItemRef = useRef(null);

  const scrollMenuByOne = (direction) => {
    const listEl = iconListRef.current;
    if (!listEl) return;
    const itemEl = iconItemRef.current;
    const itemHeight = itemEl?.offsetHeight || 48;
    const gap = 16;
    const delta = direction === "up" ? -(itemHeight + gap) : itemHeight + gap;
    listEl.scrollBy({ top: delta, behavior: "smooth" });
  };

  const getToken = async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUDIENCE_URL,
      });

      setCheckToken(token);
      return token;
    } catch (error) {
            throw error;
    }
  };

  useEffect(() => {
    const fetchToken = async () => {
      if (!isLoading) {
        if (isAuthenticated) {
          if (checkToken === null) {
            const token = await getToken();
            localStorage.setItem("token", token);
            dispatch(setUserAccessTokenAction(token));
          } else {
            dispatch(setUserAccessTokenAction(checkToken));
          }
        } else {
          localStorage.removeItem("token");
          navigate("/login");
        }
      }
    };

    fetchToken();
  }, [isAuthenticated, checkToken, isLoading]);

  const toggleMenu = () => {
    setMenuOpen((prevMenuOpen) => !prevMenuOpen);
  };

  const fetchUserProfileDetails = () => {
    if (!userInfo?._id && accessToken) {
      dispatch(
        getProfileAction({
          callback: (res) => {
            if (res?.type === 1 && res?.data?.length !== 0) {
              const selectedProfile = pickPreferredCmsProfile(res?.data);
              dispatch(updateUserProfileInfoAction(selectedProfile));
            }
          },
        })
      );
    }
  };

  const fetchLanguageList = () => {
    let languageList = localStorage.getItem("languageList");
    languageList = languageList ? JSON.parse(languageList) : null;
    if ((!languageList || languageList?.length === 0) && accessToken) {
      dispatch(
        getLanguageListAction({
          callback: (res) => {
            if (res?.type === 1 && res?.data?.length !== 0) {
              const languageList = {};
              res?.data?.map((d) => (languageList[d.language_code] = d?.language_name));
              dispatch(updateRawLanguageListAction(languageList));
              localStorage.setItem("languageList", JSON.stringify(languageList));
            }
          },
        })
      );
    } else if (!rawLanguagesList || Object.keys(rawLanguagesList ?? {})?.length === 0) {
      dispatch(updateRawLanguageListAction(languageList));
    }
  };

  useEffect(() => {
    fetchUserProfileDetails();
    fetchLanguageList();
  }, [userInfo, accessToken]);

  useEffect(() => {

    let menus = iconArray;
    const pathname = location?.pathname || "";

    if (userInfo?.roleName === "Channel Admin") {
      setActiveMenus(ChannelFieldTabsIconArray);
      return;
    }
    if (userInfo?.roleName === "Church Admin") {
      setActiveMenus(ChurchFieldTabsIconArray);
      return;
    }
    if (userInfo?.roleName === "Ministry Admin") {
      setActiveMenus(MinistryFieldTabsIconArray);
      return;
    }
    const hostMode = getCurrentHostMode();
    const portalAccess = resolveProfilePortalAccess(userInfo || {});

    // On churches/channels/ministries hosts, keep UI limited to entity portals only.
    if (hostMode !== "cms") {
      if (portalAccess === "all") {
        if (hostMode === "churches") {
          setActiveMenus(churchPortalOnlyIconArray);
          return;
        }
        if (hostMode === "channels") {
          setActiveMenus(channelPortalOnlyIconArray);
          return;
        }
        if (hostMode === "ministries") {
          setActiveMenus(ministryPortalOnlyIconArray);
          return;
        }
      }
      if (portalAccess === "church") {
        setActiveMenus(churchPortalOnlyIconArray);
        return;
      }
      if (portalAccess === "channel") {
        setActiveMenus(channelPortalOnlyIconArray);
        return;
      }
      if (portalAccess === "ministry") {
        setActiveMenus(ministryPortalOnlyIconArray);
        return;
      }
    }

    if (portalAccess === "church") {
      setActiveMenus(churchPortalOnlyIconArray);
      return;
    }
    if (portalAccess === "channel") {
      setActiveMenus(channelPortalOnlyIconArray);
      return;
    }
    if (portalAccess === "ministry") {
      setActiveMenus(ministryPortalOnlyIconArray);
      return;
    }

    if (userInfo?._id) {
      switch (userInfo?.roleCode) {
        case SUPER_ADMIN:
          menus = superAdminIconArray;
          break;
        case CMS_ADMIN:
          menus = cmsAdminIconArray;
          break;
        case TESTIMONIAL_ADMIN:
          menus = testimonialAdminIconArray;
          break;
        case CURRICULUM_ADMIN:
          menus = curriculumAdminIconArray;
          break;
        default:
          menus = iconArray;
      }
    }

    switch (selectedTab) {
      case "TWG":
        menus = TWGIconArray;
        break;
      case "Churches":
        menus = ChurchesIconArray;
        break;
      case "Channels":
        menus = ChannelsIconArray;
        break;
      case "Ministries":
        menus = MinistriesIconArray;
        break;
      default:
        // do nothing, keep role-based menus
    }

    setActiveMenus(menus);

  }, [userInfo, selectedTab, location?.pathname]);

  // Show skeleton until userInfo is loaded (has _id from profile)
  if (!userInfo || !userInfo._id) {
    return (
      <div className="">
        {/* Desktop Navbar Skeleton */}
        <div className="md:block hidden DESKTOP-NAV max-h-[96vh] h-full py-0 w-24 fixed top-5 z-20">
          <div className="h-full flex flex-col items-center bg-blackishV2 p-2 rounded-2xl border border-greyishV2 border-opacity-50 overflow-auto">
            <div className="w-14 h-14 rounded-lg bg-greyishV2/50 animate-pulse" />
            <div className="h-3 w-12 mt-4 mb-2 rounded bg-greyishV2/50 animate-pulse" />
            <ul className="flex flex-col items-center gap-4">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <li key={i} className="w-10 h-10 rounded-lg bg-greyishV2/50 animate-pulse" />
              ))}
            </ul>
          </div>
        </div>
        {/* Mobile Navbar Skeleton */}
        <nav className="MOBILE-NAV md:hidden flex items-center justify-between bg-blackish shadow-lg fixed top-0 left-0 p-4 z-[70] w-full">
          <div className="flex items-center justify-between w-full">
            <div className="w-8 h-8 rounded bg-greyishV2/50 animate-pulse" />
            <div className="w-12 h-12 rounded-lg bg-greyishV2/50 animate-pulse" />
          </div>
        </nav>
      </div>
    );
  }

  return (
    <div className="">
      <NavigationConfirmModal />
      {/* Desktop Navbar */}
      <div className="md:block hidden DESKTOP-NAV max-h-[96vh] h-full py-0 w-24 fixed top-5 z-20">
        <div className="h-full flex flex-col items-center bg-blackishV2 p-2 rounded-2xl border border-greyishV2 border-opacity-50 overflow-auto">
          <Link to={"/"}>
            <img src={logo} alt="" className="px-2" />
          </Link>
          <div className="mt-3 mb-2 flex items-center gap-2 text-yellowish">
            <button
              type="button"
              onClick={() => scrollMenuByOne("up")}
              aria-label="Scroll menu up"
            >
              <FiChevronUp className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => scrollMenuByOne("down")}
              aria-label="Scroll menu down"
            >
              <FiChevronDown className="w-5 h-5" />
            </button>
          </div>
          <div className="w-full">
            <ul
              ref={iconListRef}
              className="ICON-DIV flex flex-col items-center gap-4 max-h-[70vh] overflow-y-auto scroll-smooth"
            >
            {activeMenus.map((item, i) => {
              if (!item?.route) return null;
              const currentPath = `${location.pathname}${location.search || ""}`;
              const isItemActive = item.route.includes("?")
                ? currentPath === item.route
                : location.pathname === item.route;

              return (
                <NavLink
                  key={i}
                  to={isAuthenticated ? item.route : "/login"}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={item.title}
                  className={isItemActive ? `${navActiveCss}` : `${navHoverCss}`}
                >
                  <li
                    ref={i === 0 ? iconItemRef : null}
                    className="relative cursor-pointer p-3"
                  >
                    <img src={item.icon} alt="menu icon" className="w-[24px] h-[24px]" />
                  </li>
                  <Tooltip className="z-50" id="my-tooltip" place="right" />
                </NavLink>
              );
            })}
            </ul>
          </div>
        </div>
      </div>
      {/* Mobile Navbar */}

<nav className="MOBILE-NAV md:hidden flex items-center justify-between bg-blackish shadow-lg fixed top-0 left-0 p-4 z-[70] w-full">
  <div className="flex items-center justify-between w-full">
    <div
      className={`hamburger-icon cursor-pointer ${menuOpen ? "open" : ""}`}
      onClick={toggleMenu}
    >
      <div className="hamburger-line"></div>
      <div className="hamburger-line"></div>
      <div className="hamburger-line"></div>
    </div>
    <Link className="text-white ml-4 font-bold" to={"/login"}>
      <img className="h-12 w-12 object-contain cursor-pointer" src={logo} alt="" />
    </Link>
  </div>

  {/* Mobile Menu */}
  <div
    onMouseOver={() => setHovered(true)}
    className={`mobile-menu ${menuOpen ? "open" : ""}`}
  >
    {/* 👇 Tabs with horizontal scroll */}
    {/* <div className="w-full overflow-x-auto whitespace-nowrap px-2 py-2 scrollbar-hide">
      <Tab />
    </div> */}

    {/* <p className="text-lg text-greyish mt-4 mb-2 text-center">Menus</p> */}

    {/* Menu items */}
    {/* <ul className="ICON-DIV flex flex-col items-center gap-4 mt-6">
      {activeMenus.map((item, i) => (
        <NavLink
          key={i}
          to={isAuthenticated ? item.route : "/login"}
          className={({ isActive, isPending }) =>
            isPending ? "" : isActive ? `${navActiveCss} h-10` : `${navHoverCss} h-10`
          }
        >
          <li className="relative cursor-pointer p-2">
            <img
              src={hovered ? (item?.hover ? item?.hover : item.icon) : item.icon}
              alt="menu icon"
            />
          </li>
        </NavLink>
      ))}
    </ul> */}
  </div>
</nav>

    </div>
  );
}

export default Navbar;

